import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { AdministrationMessageItem } from '../types-store';

export const normalizeMessage = (message: AdministrationMessageItem,
  forcePublish: boolean): AdministrationMessageItem => {
  return {
    ...(!!message && isDefinedIncludingZero(message.id) && { id: message.id }),
    active: forcePublish || (!!message && !!message.active),
    translations: message && message.translations || []
  } as AdministrationMessageItem;
};
